'use client'

import { useEffect, useState } from 'react'

type Star = {
  left: string
  top: string
  duration: string
  delay: string
  opacity: number
  size: string
}

/**
 * Animated star background.
 *
 * Stars are generated only AFTER hydration (in useEffect), so the server
 * render and the first client render both produce an empty container —
 * no hydration mismatch. The previous implementation injected <div>s via
 * an inline script before React hydrated, which caused:
 *   "Did not expect server HTML to contain a <div> in <div>".
 */
export default function StarField() {
  const [stars, setStars] = useState<Star[]>([])

  useEffect(() => {
    const generated: Star[] = Array.from({ length: 120 }, () => ({
      left: `${Math.random() * 100}%`,
      top: `${Math.random() * 100}%`,
      duration: `${2 + Math.random() * 4}s`,
      delay: `${Math.random() * 4}s`,
      opacity: 0.3 + Math.random() * 0.7,
      size: `${1 + Math.random() * 2}px`,
    }))
    setStars(generated)
  }, [])

  return (
    <div className="stars-bg" id="stars-bg" aria-hidden="true">
      {stars.map((s, i) => (
        <span
          key={i}
          className="star"
          style={{
            left: s.left,
            top: s.top,
            opacity: s.opacity,
            width: s.size,
            height: s.size,
            // CSS custom props consumed by the `twinkle` keyframes.
            ['--duration' as string]: s.duration,
            ['--delay' as string]: s.delay,
          }}
        />
      ))}
    </div>
  )
}
